"<template>
  <q-page>
    <div class="q-pa-md q-gutter-sm">
      <Breadcrumbs path-name="product" :path-method="(isEdit) ? 'edit': 'create'" />
      <div class="row q-gutter-sm">
        <div v-show="isEdit" class="col col-xs-12 col-sm-6 col=md-6 col-lg-6">
          <ProductImage :image-src="productImageSrc" />
        </div>
        <div class="col col-xs-12 col-sm-5 col=md-5 col-lg-5">
          <div class="row q-gutter-sm">
            <div class="col-12">
              <q-radio v-model="productDetail.is_active" :val="0" label="不啟用" />
              <q-radio v-model="productDetail.is_active" :val="1" label="啟用" />
            </div>
            <div class="col-12">
              <q-radio v-model="productDetail.is_single" :val="0" label="非單一產品" />
              <q-radio v-model="productDetail.is_single" :val="1" label="單一產品" />
            </div>
            <div class="col-12">
              <q-select filled v-model="productDetail.category_id" :options="categoryList" option-value="OnlineId" option-label="title" emit-value map-options label="產品分類" />
            </div>
            <div class="col-12">
              <q-select filled v-model="productDetail.tag" :options="tagList" option-value="id" option-label="title" emit-value map-options multiple label="標籤" />
            </div>
            <div class="col-12">
              <q-input filled v-model="productDetail.title" label="物料名稱" />
            </div>
            <div class="col-12">
              <q-input filled v-model="productDetail.nick_name" label="物料暱稱" />
            </div>
            <div class="col-12">
              <q-input v-show="isEdit" filled v-model="productDetail.stock" :dense="false" readonly label="總庫存量" />
            </div>
            <div class="col-12">
              <div class="row q-gutter-sm">
                <div class="col">
                  <q-input filled v-model="productDetail.safe_stock" type="number" :dense="false" label="安全庫存" />
                </div>
                <div class="col">
                  <q-input filled v-model="productDetail.notice_day" type="number" :dense="false" label="進貨有效期提前提醒天數" />
                </div>
              </div>
             
            </div>
            <div class="col-12">
              <div class="row q-gutter-sm">
                <div class="col">
                  <q-input filled v-model="productDetail.price" type="number" :dense="false" label="建議售價" />
                </div>
                <div class="col">
                  <q-input filled v-model="productDetail.cost_price" type="number" :dense="false" label="進貨成本價" />
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row q-gutter-sm">
                <div class="col"><q-input filled v-model="productDetail.sell_unit" :dense="false" label="單位" /></div>
                <div v-if="false" class="col"><q-input filled v-model="productDetail.sell_quantity" type="number" :dense="false" label="數量" /></div>
                <div v-show="!productDetail.is_single" class="col">
                  <q-input filled v-model="productDetail.inner_quantity" type="number" :dense="false" label="內容數量" />
                </div>
              </div>
            </div>
            <div class="col-12">
              <q-input filled v-model="productDetail.spec" type="textarea" :dense="false" label="備註" />
            </div>
          </div>
        </div>
      </div>
      <div v-show="isEdit" class="row">
        <div class="col">
          <q-uploader
            v-if="handleEditPermission()"
            :url="productUploadLink"
            :headers="[{name: 'Dentist-Auth', value: `${apiToken()}`}]"
            :form-fields="[{ name: 'id', value: productDetail.id }]"
            label="物料圖片上傳"
            field-name="file"
            accept="image/*"
            max-files="1"
            @rejected="handleRejected"
            @uploaded="productImageUploadRefresh"
            style="width:100%;"></q-uploader>
        </div>
      </div>

      <div v-show="isEdit" class="row q-gutter-sm">
        <StockLocker :col-span="7" :can-edit="handleEditPermission()" />
        <CompanyList :col-span="4" :can-edit="handleEditPermission()"/>
      </div>
      <LogList v-show="isEdit" />
    </div>
    <q-page-sticky position="top-right" :offset="[18, 18]">
      <q-btn v-if="productDetail.PrevProduct && productDetail.PrevProduct.id !== 0" color="green" icon="skip_previous" :label="productDetail.PrevProduct.title" @click="handleGoPage(productDetail.PrevProduct.id)" class="q-mr-xs"/>
      <q-btn v-if="productDetail.NextProduct && productDetail.NextProduct.id !== 0" color="green" icon="skip_next" :label="productDetail.NextProduct.title" @click="handleGoPage(productDetail.NextProduct.id)" class="q-mr-xs"/>
      <q-btn v-if="handleEditPermission()" color="accent" icon="save" label="儲存" @click="handleSaveClick"/>
    </q-page-sticky>
  </q-page>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { getToken } from "@/utils/token"
  import { GoPageAndReload } from "@/utils"
  import Breadcrumbs from '@/components/Breadcrumbs'
  import StockLocker from './components/StockLocker'
  import CompanyList from './components/CompanyList'
  import LogList from './components/Logs'
  import ProductImage from '@/components/ProductImage'
  
  export default {
    name: "ProductDetail",
    components: { Breadcrumbs, StockLocker, CompanyList, LogList, ProductImage },
    data() {
      return {
        isEdit: false,
        productImageSrc: ""
      }
    },
    computed: {
      ...mapGetters(['productDetail', 'categoryList', 'tagList', 'productStockCount', 'productUploadLink', 'loginUser'])
    },
    created() {
      this.$store.dispatch('categoryGetList');
      this.$store.dispatch('GetLocalIP');
      this.$store.dispatch('TagList');
      
      if (this.$router.$checkRouterIsEdit(this.$route.path)) {
        this.isEdit = true
        this.$store.dispatch('productGetDetail', this.$route.params.id)
          .then(res => {
            if (!res.answer) {
              this.$router.push({ path: '/product/list' })
            } else {
              this.productImageSrc = this.productDetail.image
            }
          })
      }else {
        // copy no init
        if (this.$route.query.type !== "copy") {
          this.$store.dispatch('productCreateInit')
        }
      }
    },
    methods: {
      handleSaveClick() {
        if (this.isEdit) {
          this.update()
        }else {
          this.store()
        }
      },
      apiToken() {
        return getToken()
      },
      store() {
        this.$store.dispatch('productCreate')
        .then(res => {
          if (res.Answer) {
            // GoPageAndReload(`/product/edit/${res.ProductID}`)
            this.$store.dispatch('productCreateInit')
          }
        })
      },
      update() {
        this.$store.dispatch('productPutUpdateDetail')
      },
      handleRejected (rejectedEntries) {
        this.$q.notify({
          type: 'negative',
          message: `${rejectedEntries.length} file(s) did not pass validation constraints`
        })
      },
      handleGoPage(id) {
        GoPageAndReload(`/product/edit/${id}`)
        
      },
      handleEditPermission() {
        if (this.loginUser.permission && this.loginUser.permission.Product > 2) {
          return true
        } else {
          return false
        }
      },
      ...mapActions(['productImageUploadRefresh'])
    }
  }
</script>

<style scoped>

</style>
